import { Text, TextField, View, TextArea } from "reshaped";
import { useResponsiveClientValue } from "../../../hooks";

export const Contact = () => {
  const responsiveColumns = useResponsiveClientValue({ s: 12, l: 4 });

  return (
    <View direction="column" gap={5}>
      <Text align="center" variant="title-6">
        Contactame
      </Text>
      <Text align="center" variant="featured-2" weight="bold">
        Que Necesita
      </Text>

      <View direction="row" gap={10} justify="center">
        <View.Item columns={responsiveColumns}>
          <Text variant="featured-3" weight="bold">
            Si está interesado en desarrollar una página web para su negocio o
            empresa, no dude en ponerse en contacto conmigo. Estoy disponible
            para discutir sus necesidades y proporcionarle un presupuesto
            personalizado. ¡Espero con interés la oportunidad de colaborar en la
            creación de su presencia en línea!
          </Text>
        </View.Item>

        <View.Item columns={responsiveColumns}>
          <View gap={5}>
            <TextField placeholder="Nombre" size="xlarge" />
            <TextField placeholder="Email" size="xlarge" />
            <TextField placeholder="Objetivo" size="xlarge" />
            <TextArea placeholder="Mensaje" size="xlarge" />
          </View>
        </View.Item>
      </View>
    </View>
  );
};
